import { X, Sparkles, Search, Lightbulb, Shield, Users, Newspaper } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import FeedbackButtons, { SUGGESTION_REASONS } from "@/components/FeedbackButtons";
import { ageLabel } from "../stream/streamModel";

const MODES = {
  prospect: { Icon: Users, title: "Prospect Discovery" },
  research: { Icon: Search, title: "Account Research" },
  strategy: { Icon: Lightbulb, title: "Sales Strategy" },
  competitor: { Icon: Shield, title: "Competitive Alert" },
  news: { Icon: Newspaper, title: "News" },
};
const DEFAULT_MODE = { Icon: Sparkles, title: "AI Insights" };

export const InsightHeader = ({ activityData, userId, onClose }) => {
  const mode = MODES[activityData?.type] || DEFAULT_MODE;
  const published = ageLabel(activityData?.publishedAt || activityData?.newsItems?.[0]?.publishedAt);
  return (
    <div className="sticky top-0 z-10 bg-[#0f1419] border-b border-white/10 px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-ism-teal/10 border border-ism-teal/20 flex items-center justify-center">
            <mode.Icon className="h-5 w-5 text-ism-teal" />
          </div>
          <div>
            <h2 className="text-base md:text-lg font-medium text-white">{mode.title}</h2>
            <div className="flex items-center gap-2 mt-1">
              <Badge className="bg-ism-teal/10 text-ism-teal border border-ism-teal/20 text-xs font-medium uppercase tracking-wider">{activityData.type}</Badge>
              {activityData.lensLabel && <Badge className="bg-white/5 text-gray-300 border border-white/10 text-xs">{activityData.lensLabel}</Badge>}
              {activityData.researchTarget && <Badge className="bg-white/5 text-gray-300 border border-white/10 text-xs">{activityData.researchTarget}</Badge>}
              {published && <Badge className="bg-white/5 text-gray-300 border border-white/10 text-xs" data-testid="insight-published">Published {published}</Badge>}
              {activityData.totalResults > 0 && (
                <Badge className="bg-ism-teal/10 text-ism-teal border border-ism-teal/20 text-xs">{activityData.totalResults} found</Badge>
              )}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <FeedbackButtons
            userId={userId}
            agentType="autonomous_stream"
            actionId={activityData?.actionId}
            outputSummary={activityData?.summary}
            context={{ type: activityData?.type, kind: "suggestion" }}
            reasons={SUGGESTION_REASONS}
            testIdPrefix="insight"
          />
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors" data-testid="insight-close-btn">
            <X className="h-6 w-6" />
          </button>
        </div>
      </div>
    </div>
  );
};
